<div class="row footerdiv">
  <hr class="hrcust">
  <p class="copyright">
    finzy is owned and operated by Bridge Fintech Solutions Private Limited
    <br/>
    © 2017-2018 finzy. All rights reserved.
  </p>
</div>